import { render, staticRenderFns } from "./DocumentsProductCategory.vue?vue&type=template&id=7e135ad8"
import script from "./DocumentsProductCategory.vue?vue&type=script&lang=js"
export * from "./DocumentsProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports